var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner-wrapper flex-row flex-all-center",class:{ inside: _vm.range === 'inside', 'shade—mode': _vm.shadeMode }},[(_vm.type === 'loading')?_c('img',{staticClass:"loading",attrs:{"src":require("@assets/images/loading.svg")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }